var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Iconly/Bulk/Category",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M15.483 0h3.725A2.8 2.8 0 0122 2.816v3.756a2.8 2.8 0 01-2.792 2.816h-3.725a2.8 2.8 0 01-2.792-2.816V2.816A2.8 2.8 0 0115.483 0",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M15.483 22a2.8 2.8 0 01-2.792-2.816v-3.756a2.8 2.8 0 012.792-2.817h3.725A2.8 2.8 0 0122 15.428v3.756A2.8 2.8 0 0119.208 22zm-12.69 0A2.8 2.8 0 010 19.184v-3.756a2.8 2.8 0 012.793-2.817h3.724a2.8 2.8 0 012.792 2.817v3.756A2.8 2.8 0 016.517 22zm0-12.612A2.8 2.8 0 010 6.572V2.816A2.8 2.8 0 012.793 0h3.724a2.8 2.8 0 012.792 2.816v3.756a2.8 2.8 0 01-2.792 2.816z"
  })));
}

export default SvgDashboard;